import { random } from 'lodash';
import { z } from 'zod';
import { legalTransactionRelationshipDocumentSchema } from './ILegalTransactionRelationshipDocument';
import { legalTransactionRelationshipMemberSchema } from './ILegalTransactionRelationshipMember';
import { legalTransactionRelationshipRealEstateSchema } from './ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { partnerIdentifierSchema } from './IPartnerIdentifier';
import { LegalTransactionRelationshipTypeEnum } from './LegalTransactionRelationshipTypeEnum';
import { AssetSchema } from '../Asset/IAsset';

/** Direkt am Vorgang verknüpftes Grundbuchblatt (Blatt-zentrischer Umbau #1108). */
export const legalTransactionGrundbuchblattLinkSchema = z.object({
  idGrundbuchblatt: z.number(),
  Blattnummer: z.string().optional(),
  idCourt: z.number().nullable().optional(),
  idAdministrativeUnit: z.number().nullable().optional(),
  Amtsgericht: z.string().nullable().optional(),
  Gemarkung: z.string().nullable().optional(),
  FlurstueckAnzahl: z.number().nullable().optional(),
  AdressAnzahl: z.number().nullable().optional(),
});

export type ILegalTransactionGrundbuchblattLink = z.infer<
  typeof legalTransactionGrundbuchblattLinkSchema
>;

export const legalTransactionRelationshipSchema = z.object({
  idRelationship: z.number(),
  idRelationshipType: z.nativeEnum(LegalTransactionRelationshipTypeEnum),
  RelationshipType: z.string(),
  idLegalTransaction: z.number(),
  isActiveRelationship: z.boolean(),
  companyFormationLegalTransaction: z.string().nullable().optional(),
  isCompanyFormation: z.boolean(),
  data: z.record(z.any()).nullable(),
  syncWithArnoTop: z.boolean(),
  Created: z.date(),
  Updated: z.date(),
  Members: z.array(legalTransactionRelationshipMemberSchema),
  DocumentArray: z.array(legalTransactionRelationshipDocumentSchema),
  RealEstateArray: z.array(legalTransactionRelationshipRealEstateSchema),
  GrundbuchblattArray: z
    .array(legalTransactionGrundbuchblattLinkSchema)
    .optional(),
  PartnerIdentifiers: z.array(partnerIdentifierSchema),
  AssetArray: z.array(AssetSchema).optional(),
  Version: z.number().optional(),
});

export type ILegalTransactionRelationship = z.infer<
  typeof legalTransactionRelationshipSchema
>;

export const initLegalTransactionRelationship =
  (): ILegalTransactionRelationship => ({
    idRelationship: -random(1, Number.MAX_SAFE_INTEGER),
    idRelationshipType: LegalTransactionRelationshipTypeEnum.PurchaseContract,
    RelationshipType: '',
    idLegalTransaction: 0,
    isActiveRelationship: true,
    companyFormationLegalTransaction: null,
    isCompanyFormation: false,
    data: null,
    syncWithArnoTop: false,
    Created: new Date(),
    Updated: new Date(),
    Members: [],
    DocumentArray: [],
    RealEstateArray: [],
    GrundbuchblattArray: [],
    PartnerIdentifiers: [],
    AssetArray: [],
  });
